<template>
	<div class="user-avatar-dropdown">
		<Dropdown @on-click="handleClick">
			<Badge :dot="!!messageUnreadCount">
				<Avatar src="" />
			</Badge>
			<Icon :size="30" type="md-arrow-dropdown"></Icon>
			<DropdownMenu slot="list">
				<DropdownItem name="roleAuthority" v-if="userInfo.role_type==4 || userInfo.role_type==1">
					角色权限<Badge style="margin-left: 10px" :count="messageUnreadCount"></Badge>
				</DropdownItem>
				<DropdownItem name="organizationMember"v-if="userInfo.role_type==1 || userInfo.role_type==4  ||userInfo.role_type==5 ||userInfo.role_type==13">
					组织成员<Badge style="margin-left: 10px" :count="messageUnreadCount"></Badge>
				</DropdownItem>
				<DropdownItem name="logout">退出登录</DropdownItem>
			</DropdownMenu>
		</Dropdown>
	</div>
</template>

<script>
	import './user.less'
	import {
		mapActions
	} from 'vuex'
	export default {
		name: 'User',
		props: {
			userInfo:{
				
			},
			userAvatar: {
				type: String,
				default: ''
			},
			messageUnreadCount: {
				type: Number,
				default: 0
			}
		},
		methods: {
			...mapActions([
				'handleLogOut'
			]),
			logout() {
				this.handleLogOut();
				this.$router.push({
					name: 'login'
				})
			},
			roleAuthority() {
				this.$router.push({
					name: 'roleAuthority'
				})
			},
			organizationMember() {
				this.$router.push({
					name: 'organizationMember'
				})
			},
			handleClick(name) {
				switch (name) {
					case 'logout':
						this.logout()
						break
					case 'roleAuthority':
						this.roleAuthority()
						break
					case 'organizationMember':
						this.organizationMember()
						break
				}
			}
		}
	}
</script>
